<template>
	<v-card outlined class="period-bar px-3 py-2">
		<div class="d-flex flex-wrap align-center" style="gap: 8px 12px">
			<v-btn-toggle :value="value.period" mandatory dense color="primary" @change="update({ period: $event })">
				<v-btn small value="month">Mese</v-btn>
				<v-btn small value="quarter">Trimestre</v-btn>
				<v-btn small value="year">Anno</v-btn>
				<v-btn small value="custom">Date</v-btn>
			</v-btn-toggle>

			<template v-if="value.period === 'custom'">
				<v-text-field :value="value.from" type="date" label="Dal" dense outlined hide-details class="field-date" @change="update({ from: $event })" />
				<v-text-field :value="value.to" type="date" label="Al" dense outlined hide-details class="field-date" @change="update({ to: $event })" />
			</template>
			<template v-else>
				<v-select v-if="value.period === 'month'" :value="value.month" :items="months" label="Mese" dense outlined hide-details class="field-sm" @change="update({ month: $event })" />
				<v-select v-if="value.period === 'quarter'" :value="value.quarter" :items="quarters" label="Trimestre" dense outlined hide-details class="field-xs" @change="update({ quarter: $event })" />
				<v-select :value="value.year" :items="years" label="Anno" dense outlined hide-details class="field-xs" @change="update({ year: $event })" />
			</template>

			<v-select :value="value.compare" :items="compares" label="Confronta con" dense outlined hide-details class="field-md" @change="update({ compare: $event })" />
			<v-select v-if="showPlatform" :value="value.platform" :items="platformItems" label="Canale" dense outlined hide-details class="field-sm" @change="update({ platform: $event })" />

			<v-spacer />
			<span v-if="partial" class="text-caption grey--text">Periodo in corso: confronto a parità di giorni</span>
			<v-btn small outlined color="primary" :loading="loading" @click="$emit('refresh')">
				<v-icon small left>mdi-refresh</v-icon>
				Aggiorna
			</v-btn>
			<v-btn v-if="showReport" small depressed color="primary" @click="$emit('report')">
				<v-icon small left>mdi-file-pdf-box</v-icon>
				Report PDF
			</v-btn>
		</div>
	</v-card>
</template>

<script>
import { MONTHS } from './format';

export default {
	name: 'PeriodBar',
	props: {
		value: { type: Object, required: true },
		platforms: { type: Array, default: () => [] },
		partial: { type: Boolean, default: false },
		loading: { type: Boolean, default: false },
		// le Statistiche (Google Analytics) non hanno canali di vendita ne' report PDF
		showPlatform: { type: Boolean, default: true },
		showReport: { type: Boolean, default: true },
	},
	data() {
		const current = new Date().getFullYear();
		return {
			months: MONTHS,
			quarters: [1, 2, 3, 4].map(q => ({ value: q, text: `Q${q}` })),
			years: Array.from({ length: 6 }, (_, i) => current - i),
			compares: [
				{ value: 'prev', text: 'Periodo precedente' },
				{ value: 'yoy', text: "Stesso periodo anno prima" },
			],
		};
	},
	computed: {
		platformItems() {
			return [{ value: '', text: 'Tutti i canali' }, ...this.platforms.map(p => ({ value: p, text: p }))];
		},
	},
	methods: {
		update(patch) {
			this.$emit('input', { ...this.value, ...patch });
		},
	},
};
</script>

<style scoped>
.field-xs {
	max-width: 110px;
}
.field-sm {
	max-width: 160px;
}
.field-md {
	max-width: 230px;
}
.field-date {
	max-width: 170px;
}
</style>
